import React, { HTMLProps } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import styles from './menu.module.scss';

interface IProps extends HTMLProps<HTMLElement> {
    className?: string;
    title?: string;
    children: React.ReactNode;
    active?: boolean;
}

function MenuListItem(props: IProps) {
    const { className, title, active, children, ...rest } = props;
    return (
        <Element
            renderAs="li"
            className={classnames(className, { [styles['is-active']]: active })}
            {...rest}
        >
            {children}
        </Element>
    );
}

export default MenuListItem;
